module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caldera-config-group"
  }, [_c('div', {
    staticClass: "caldera-config-field"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deliveryValue),
      expression: "deliveryValue"
    }],
    attrs: {
      "type": "checkbox",
      "id": "cf-pro-enhanced-delivery",
      "aria-describedby": "cf-pro-enhanced-delivery-desc"
    },
    domProps: {
      "checked": Array.isArray(_vm.deliveryValue) ? _vm._i(_vm.deliveryValue, null) > -1 : (_vm.deliveryValue)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.deliveryValue,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deliveryValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deliveryValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deliveryValue = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "cf-pro-enhanced-delivery"
    }
  }, [_vm._v("\n\t\t\tEnable Enhanced Delivery\n\t\t")]), _vm._v(" "), _c('div', {
    staticClass: "description",
    attrs: {
      "id": "cf-pro-enhanced-delivery-desc"
    }
  }, [_c('p', [_vm._v("If enabled, messages are sent via Caldera Forms Pro Servers")]), _vm._v(" "), (_vm.enhancedDelivery) ? _c('ul', [_c('li', [_vm._v("Forms must use database entry tracking.")]), _vm._v(" "), _c('li', [_vm._v("From Email setting will be used as the reply-to.")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ad2672a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/GeneralSettings/enhancedDelivery.vue
// module id = 224
// module chunks = 1